import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import '../style/app.scss';
declare var jQuery: any;

@Component({
  selector: 'my-app', // <my-app></my-app>
  template: require('./app.component.html'),
  styles: [require('./app.component.scss')],
})
export class AppComponent implements OnInit, AfterViewInit {

  constructor(private router: Router) { }

  ngOnInit() {
        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            if (evt.url.indexOf('#') > 0) {
                return;
            }
            window.scrollTo(0, 0);
        });
  }

  ngAfterViewInit() {
    jQuery('.headroom').headroom({
      'tolerance': 20,
      'offset': 50,
      'classes': {
        'initial': 'animated',
        'pinned': 'slideDown',
        'unpinned': 'slideUp'
      }
    });

    jQuery(document).on('click', '.navbar-collapse.in', function(e) {
        if (jQuery(e.target).is('a')) {
            jQuery(this).collapse('hide');
        }
    });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/app.component.ts